/**
 * Static filter option arrays for SearchResults
 * Extracted for reusability and cleaner code organization
 */

import i18n from '../i18n';

// Category options with labels and icons
export const allCategories = [
  { value: 'restaurants', get label() { return i18n.t('labels:searchFilters.categories.restaurants.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.restaurants.shortLabel'); } },
  { value: 'bars', get label() { return i18n.t('labels:searchFilters.categories.bars.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.bars.shortLabel'); } },
  { value: 'parks', get label() { return i18n.t('labels:searchFilters.categories.parks.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.parks.shortLabel'); } },
  { value: 'museums', get label() { return i18n.t('labels:searchFilters.categories.museums.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.museums.shortLabel'); } },
  { value: 'entertainment', get label() { return i18n.t('labels:searchFilters.categories.entertainment.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.entertainment.shortLabel'); } },
  { value: 'attractions', get label() { return i18n.t('labels:searchFilters.categories.attractions.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.attractions.shortLabel'); } },
  { value: 'shopping', get label() { return i18n.t('labels:searchFilters.categories.shopping.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.shopping.shortLabel'); } },
  { value: 'educational', get label() { return i18n.t('labels:searchFilters.categories.educational.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.educational.shortLabel'); } },
  { value: 'wellness', get label() { return i18n.t('labels:searchFilters.categories.wellness.label'); }, get shortLabel() { return i18n.t('labels:searchFilters.categories.wellness.shortLabel'); } }
];

// Category display name mapping
export const categoryNames = {
  get restaurants() { return i18n.t('labels:searchFilters.categoryNames.restaurants'); },
  get bars() { return i18n.t('labels:searchFilters.categoryNames.bars'); },
  get parks() { return i18n.t('labels:searchFilters.categoryNames.parks'); },
  get museums() { return i18n.t('labels:searchFilters.categoryNames.museums'); },
  get entertainment() { return i18n.t('labels:searchFilters.categoryNames.entertainment'); },
  get attractions() { return i18n.t('labels:searchFilters.categoryNames.attractions'); },
  get shopping() { return i18n.t('labels:searchFilters.categoryNames.shopping'); },
  get educational() { return i18n.t('labels:searchFilters.categoryNames.educational'); },
  get wellness() { return i18n.t('labels:searchFilters.categoryNames.wellness'); },
  get family() { return i18n.t('labels:searchFilters.categoryNames.family'); }
};

// Dining options for food-related venues
export const diningOptions = [
  { value: 'outdoor_seating', get label() { return i18n.t('labels:searchFilters.dining.outdoorSeating'); }, attribute: 'outdoor_seating' },
  { value: 'serves_vegetarian_food', get label() { return i18n.t('labels:searchFilters.dining.vegetarian'); }, attribute: 'serves_vegetarian_food' },
  { value: 'serves_coffee', get label() { return i18n.t('labels:searchFilters.dining.coffee'); }, attribute: 'serves_coffee' },
  { value: 'serves_dessert', get label() { return i18n.t('labels:searchFilters.dining.dessert'); }, attribute: 'serves_dessert' },
  { value: 'serves_breakfast', get label() { return i18n.t('labels:searchFilters.dining.breakfast'); }, attribute: 'serves_breakfast' },
  { value: 'serves_lunch', get label() { return i18n.t('labels:searchFilters.dining.lunch'); }, attribute: 'serves_lunch' },
  { value: 'serves_dinner', get label() { return i18n.t('labels:searchFilters.dining.dinner'); }, attribute: 'serves_dinner' },
  { value: 'serves_beer', get label() { return i18n.t('labels:searchFilters.dining.beer'); }, attribute: 'serves_beer' },
  { value: 'serves_wine', get label() { return i18n.t('labels:searchFilters.dining.wine'); }, attribute: 'serves_wine' },
  { value: 'serves_cocktails', get label() { return i18n.t('labels:searchFilters.dining.cocktails'); }, attribute: 'serves_cocktails' },
  { value: 'live_music', get label() { return i18n.t('labels:searchFilters.dining.liveMusic'); }, attribute: 'live_music' }
];

// Service options (takeout, delivery, etc.)
export const serviceOptions = [
  { value: 'takeout', get label() { return i18n.t('labels:searchFilters.service.takeout'); }, attribute: 'takeout' },
  { value: 'delivery', get label() { return i18n.t('labels:searchFilters.service.delivery'); }, attribute: 'delivery' },
  { value: 'dine_in', get label() { return i18n.t('labels:searchFilters.service.dineIn'); }, attribute: 'dine_in' },
  { value: 'reservable', get label() { return i18n.t('labels:searchFilters.service.reservable'); }, attribute: 'reservable' },
  { value: 'curbside_pickup', get label() { return i18n.t('labels:searchFilters.service.curbsidePickup'); }, attribute: 'curbside_pickup' }
];

// Good for (kids, groups, etc.)
export const goodForOptions = [
  { value: 'good_for_children', get label() { return i18n.t('labels:searchFilters.goodFor.children'); }, attribute: 'good_for_children' },
  { value: 'good_for_groups', get label() { return i18n.t('labels:searchFilters.goodFor.groups'); }, attribute: 'good_for_groups' }
];

// Special attributes (cross-cutting features)
export const specialAttributes = [
  { value: 'tourist_attraction', get label() { return i18n.t('labels:searchFilters.specialAttributes.touristAttraction.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.touristAttraction.description'); } },
  { value: 'historical_landmark', get label() { return i18n.t('labels:searchFilters.specialAttributes.historicalLandmark.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.historicalLandmark.description'); } },
  { value: 'cultural_landmark', get label() { return i18n.t('labels:searchFilters.specialAttributes.culturalLandmark.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.culturalLandmark.description'); } },
  { value: 'wheelchair_accessible_entrance', get label() { return i18n.t('labels:searchFilters.specialAttributes.wheelchairAccessible.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.wheelchairAccessible.description'); } },
  { value: 'outdoor_seating', get label() { return i18n.t('labels:searchFilters.specialAttributes.outdoorSeating.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.outdoorSeating.description'); } },
  { value: 'live_music', get label() { return i18n.t('labels:searchFilters.specialAttributes.liveMusic.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.liveMusic.description'); } },
  { value: 'good_for_children', get label() { return i18n.t('labels:searchFilters.specialAttributes.familyFriendly.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.familyFriendly.description'); } },
  { value: 'good_for_groups', get label() { return i18n.t('labels:searchFilters.specialAttributes.goodForGroups.label'); }, get description() { return i18n.t('labels:searchFilters.specialAttributes.goodForGroups.description'); } }
];

// Common venue types from Google Places
export const venueTypes = [
  // Most Popular - Show First 8
  { value: 'restaurant', get label() { return i18n.t('labels:searchFilters.venueTypes.restaurant'); } },
  { value: 'bar', get label() { return i18n.t('labels:searchFilters.venueTypes.bar'); } },
  { value: 'cafe', get label() { return i18n.t('labels:searchFilters.venueTypes.cafe'); } },
  { value: 'museum', get label() { return i18n.t('labels:searchFilters.venueTypes.museum'); } },
  { value: 'park', get label() { return i18n.t('labels:searchFilters.venueTypes.park'); } },
  { value: 'shopping_mall', get label() { return i18n.t('labels:searchFilters.venueTypes.shoppingMall'); } },
  { value: 'hotel', get label() { return i18n.t('labels:searchFilters.venueTypes.hotel'); } },
  { value: 'theater', get label() { return i18n.t('labels:searchFilters.venueTypes.theater'); } },

  // Additional Types - Show More
  { value: 'historical_landmark', get label() { return i18n.t('labels:searchFilters.venueTypes.historicalLandmark'); } },
  { value: 'art_gallery', get label() { return i18n.t('labels:searchFilters.venueTypes.artGallery'); } },
  { value: 'zoo', get label() { return i18n.t('labels:searchFilters.venueTypes.zoo'); } },
  { value: 'aquarium', get label() { return i18n.t('labels:searchFilters.venueTypes.aquarium'); } },
  { value: 'amusement_park', get label() { return i18n.t('labels:searchFilters.venueTypes.amusementPark'); } },
  { value: 'playground', get label() { return i18n.t('labels:searchFilters.venueTypes.playground'); } },
  { value: 'water_park', get label() { return i18n.t('labels:searchFilters.venueTypes.waterPark'); } },
  { value: 'night_club', get label() { return i18n.t('labels:searchFilters.venueTypes.nightClub'); } },
  { value: 'spa', get label() { return i18n.t('labels:searchFilters.venueTypes.spa'); } },
  { value: 'gym', get label() { return i18n.t('labels:searchFilters.venueTypes.gym'); } },
  { value: 'library', get label() { return i18n.t('labels:searchFilters.venueTypes.library'); } },
  { value: 'movie_theater', get label() { return i18n.t('labels:searchFilters.venueTypes.movieTheater'); } },
  { value: 'performing_arts_theater', get label() { return i18n.t('labels:searchFilters.venueTypes.performingArtsTheater'); } },
  { value: 'stadium', get label() { return i18n.t('labels:searchFilters.venueTypes.stadium'); } },
  { value: 'bowling_alley', get label() { return i18n.t('labels:searchFilters.venueTypes.bowlingAlley'); } },
  { value: 'golf_course', get label() { return i18n.t('labels:searchFilters.venueTypes.golfCourse'); } },
  { value: 'swimming_pool', get label() { return i18n.t('labels:searchFilters.venueTypes.swimmingPool'); } },
  { value: 'fitness_center', get label() { return i18n.t('labels:searchFilters.venueTypes.fitnessCenter'); } },
  { value: 'ice_skating_rink', get label() { return i18n.t('labels:searchFilters.venueTypes.iceSkatingRink'); } },
  { value: 'karaoke', get label() { return i18n.t('labels:searchFilters.venueTypes.karaoke'); } },
  { value: 'comedy_club', get label() { return i18n.t('labels:searchFilters.venueTypes.comedyClub'); } },
  { value: 'concert_hall', get label() { return i18n.t('labels:searchFilters.venueTypes.concertHall'); } },
  { value: 'opera_house', get label() { return i18n.t('labels:searchFilters.venueTypes.operaHouse'); } },
  { value: 'planetarium', get label() { return i18n.t('labels:searchFilters.venueTypes.planetarium'); } },
  { value: 'church', get label() { return i18n.t('labels:searchFilters.venueTypes.church'); } },
  { value: 'bakery', get label() { return i18n.t('labels:searchFilters.venueTypes.bakery'); } },
  { value: 'grocery_store', get label() { return i18n.t('labels:searchFilters.venueTypes.groceryStore'); } },
  { value: 'book_store', get label() { return i18n.t('labels:searchFilters.venueTypes.bookStore'); } },
  { value: 'clothing_store', get label() { return i18n.t('labels:searchFilters.venueTypes.clothingStore'); } },
  { value: 'electronics_store', get label() { return i18n.t('labels:searchFilters.venueTypes.electronicsStore'); } },
  { value: 'jewelry_store', get label() { return i18n.t('labels:searchFilters.venueTypes.jewelryStore'); } },
  { value: 'department_store', get label() { return i18n.t('labels:searchFilters.venueTypes.departmentStore'); } },
  { value: 'supermarket', get label() { return i18n.t('labels:searchFilters.venueTypes.supermarket'); } },
  { value: 'pharmacy', get label() { return i18n.t('labels:searchFilters.venueTypes.pharmacy'); } },
  { value: 'gas_station', get label() { return i18n.t('labels:searchFilters.venueTypes.gasStation'); } },
  { value: 'bank', get label() { return i18n.t('labels:searchFilters.venueTypes.bank'); } },
  { value: 'atm', get label() { return i18n.t('labels:searchFilters.venueTypes.atm'); } },
  { value: 'hospital', get label() { return i18n.t('labels:searchFilters.venueTypes.hospital'); } },
  { value: 'dentist', get label() { return i18n.t('labels:searchFilters.venueTypes.dentist'); } },
  { value: 'veterinary_care', get label() { return i18n.t('labels:searchFilters.venueTypes.veterinaryCare'); } },
  { value: 'school', get label() { return i18n.t('labels:searchFilters.venueTypes.school'); } },
  { value: 'university', get label() { return i18n.t('labels:searchFilters.venueTypes.university'); } },
  { value: 'post_office', get label() { return i18n.t('labels:searchFilters.venueTypes.postOffice'); } },
  { value: 'fire_station', get label() { return i18n.t('labels:searchFilters.venueTypes.fireStation'); } },
  { value: 'police', get label() { return i18n.t('labels:searchFilters.venueTypes.police'); } }
];

// Category to venue type mappings for auto-selection
export const categoryToVenueTypes = {
  'restaurants': [
    'restaurant', 'cafe', 'bakery', 'fast_food_restaurant',
    'bar_and_grill', 'barbecue_restaurant', 'breakfast_restaurant', 'brunch_restaurant',
    'buffet_restaurant', 'chinese_restaurant', 'coffee_shop', 'deli', 'dessert_restaurant',
    'dessert_shop', 'ice_cream_shop', 'chocolate_shop', 'candy_store',
    'diner', 'french_restaurant', 'hamburger_restaurant',
    'indian_restaurant', 'italian_restaurant', 'japanese_restaurant', 'korean_restaurant',
    'mediterranean_restaurant', 'mexican_restaurant', 'pizza_restaurant',
    'seafood_restaurant', 'steak_house', 'thai_restaurant', 'vegan_restaurant',
    'vegetarian_restaurant', 'tea_house'
  ],
  'bars': [
    'bar', 'night_club', 'wine_bar', 'pub', 'sports_bar', 'lounge',
    'cocktail_bar', 'brewery', 'dance_club', 'karaoke'
  ],
  'entertainment': [
    'movie_theater', 'night_club', 'bar', 'comedy_club', 'karaoke',
    'bowling_alley', 'amusement_park', 'aquarium', 'zoo', 'casino',
    'concert_hall', 'opera_house', 'performing_arts_theater', 'video_arcade',
    'escape_room', 'billiard_hall', 'music_venue', 'dance_club', 'pub',
    'wine_bar', 'sports_bar', 'ice_skating_rink', 'roller_skating_rink',
    'adventure_sports_center', 'amusement_center', 'recreation_center', 'trampoline_park'
  ],
  'shopping': [
    'shopping_mall', 'clothing_store', 'book_store', 'electronics_store',
    'department_store', 'gift_shop', 'jewelry_store', 'bakery', 'grocery_store',
    'supermarket', 'shoe_store', 'home_goods_store', 'furniture_store',
    'hardware_store', 'sporting_goods_store', 'toy_store', 'florist',
    'candy_store', 'liquor_store', 'convenience_store', 'discount_store'
  ],
  'museums': [
    'museum', 'art_gallery', 'historical_landmark', 'cultural_landmark',
    'planetarium', 'botanical_garden', 'church', 'monument', 'castle', 'palace',
    'cultural_center', 'observation_deck', 'lighthouse', 'bridge', 'fountain', 'memorial'
  ],
  'parks': [
    'park', 'beach', 'playground', 'golf_course', 'swimming_pool',
    'stadium', 'sports_complex', 'hiking_area', 'campground', 'marina',
    'fishing_spot', 'picnic_area', 'garden', 'nature_reserve', 'trail',
    'athletic_field', 'tennis_court', 'basketball_court', 'skate_park',
    'sports_activity_location'
  ],
  'educational': [
    'school', 'university', 'college', 'library', 'community_college',
    'primary_school', 'secondary_school', 'preschool', 'student_housing'
  ],
  'wellness': [
    'spa', 'gym', 'fitness_center', 'yoga_studio', 'massage_spa',
    'wellness_center', 'health_club', 'meditation_center', 'sauna',
    'beauty_salon', 'hair_salon', 'nail_salon', 'barber_shop'
  ],
  // Attractions - broad category for tourist destinations
  'attractions': [
    'tourist_attraction', 'museum', 'art_gallery', 'zoo', 'aquarium',
    'amusement_park', 'historical_landmark', 'monument', 'observation_deck',
    'cultural_landmark', 'planetarium', 'castle', 'palace', 'memorial',
    'botanical_garden', 'landmark', 'national_park', 'water_park',
    'theme_park', 'heritage_site', 'scenic_point'
  ],
  'family': [
    'zoo', 'aquarium', 'amusement_park', 'water_park', 'playground',
    'park', 'museum', 'bowling_alley', 'movie_theater', 'ice_skating_rink',
    'miniature_golf', 'arcade', 'family_restaurant', 'pizza_restaurant',
    'ice_cream_shop', 'candy_store', 'toy_store', 'children_museum',
    'adventure_sports_center', 'amusement_center', 'recreation_center', 'trampoline_park'
  ]
};

// Sort options for search results
export const sortOptions = [
  { value: 'recommended', get label() { return i18n.t('labels:searchFilters.sortOptions.recommended'); } },
  { value: 'rating', get label() { return i18n.t('labels:searchFilters.sortOptions.rating'); } },
  { value: 'reviews', get label() { return i18n.t('labels:searchFilters.sortOptions.reviews'); } },
  { value: 'distance', get label() { return i18n.t('labels:searchFilters.sortOptions.distance'); } },
  { value: 'price_low', get label() { return i18n.t('labels:searchFilters.sortOptions.priceLow'); } },
  { value: 'price_high', get label() { return i18n.t('labels:searchFilters.sortOptions.priceHigh'); } }
];

// Default accordion collapse state
export const defaultCollapsedSections = {
  diningServices: true,
  suitability: true,
  qualityPrice: true,
  venueTypes: true
};

// API rate limit configuration
export const API_CALL_LIMITS = {
  PER_SECOND: 2,
  PER_MINUTE: 15,
  PER_HOUR: 100,
  DAILY: 300
};

// Helper function to get category display name
export function getCategoryDisplayName(category) {
  return categoryNames[category] || category;
}

// Helper function to get available categories (not yet selected)
export function getAvailableCategories(selectedCategories) {
  return allCategories.filter(cat => !selectedCategories.includes(cat.value));
}

// Helper function to get category data by value
export function getCategoryData(categoryValue) {
  return allCategories.find(cat => cat.value === categoryValue);
}

// Reverse-lookup: map a Google Place type to its parent category key
export function getPlaceCategoryFromType(googlePlaceType) {
  if (!googlePlaceType) return null;
  for (const [category, types] of Object.entries(categoryToVenueTypes)) {
    if (types.includes(googlePlaceType)) {
      return category;
    }
  }
  return null;
}
